var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarDullIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03905 0.855893L8.26413 4.62631L8.32026 4.79905H8.50189L12.4663 4.79905L9.25904 7.12929L9.11209 7.23606L9.16822 7.4088L10.3933 11.1792L7.18599 8.84897L7.03905 8.74221L6.8921 8.84897L3.6848 11.1792L4.90988 7.4088L4.96601 7.23606L4.81906 7.12929L1.61176 4.79905L5.5762 4.79905H5.75784L5.81397 4.62631L7.03905 0.855893Z",
    stroke: "#7E7E7E",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarDullIcon);
export default __webpack_public_path__ + "static/media/star_dull_icon.69b6ec99fd96840efa47120b2451a07b.svg";
export { ForwardRef as ReactComponent };